import { render, staticRenderFns } from "./UserCards.vue?vue&type=template&id=3256af6a&scoped=true&"
import script from "./UserCards.vue?vue&type=script&lang=ts&"
export * from "./UserCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256af6a",
  null
  
)

export default component.exports